import './js/langArray';
import './js/main';